var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/**
 * ActionButton - Icon-only button for actions like edit, delete, close, etc.
 * Provides consistent styling and hover states
 */
var ActionButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, title = _a.title, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? "medium" : _c, _d = _a.variant, variant = _d === void 0 ? "default" : _d, _e = _a.className, className = _e === void 0 ? "" : _e, style = _a.style;
    var baseStyles = __assign({ background: "none", border: "none", cursor: disabled ? "not-allowed" : "pointer", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease" }, style);
    // Size variants
    var sizeStyles = {
        small: {
            padding: "2px",
            fontSize: "12px",
        },
        medium: {
            padding: "4px",
            fontSize: "14px",
        },
        large: {
            padding: "6px",
            fontSize: "16px",
        },
    };
    // Color variants
    var colorVariants = {
        default: {
            color: "#374B94",
            hoverBg: "#e8f4fd",
            hoverColor: "#2c5aa0",
        },
        primary: {
            color: "#374B94",
            hoverBg: "#374B94",
            hoverColor: "white",
        },
        secondary: {
            color: "#666",
            hoverBg: "#f8f9fa",
            hoverColor: "#333",
        },
        danger: {
            color: "#dc3545",
            hoverBg: "#f5c6cb",
            hoverColor: "#721c24",
        },
        success: {
            color: "#28a745",
            hoverBg: "#d4edda",
            hoverColor: "#155724",
        },
    };
    var colorStyle = colorVariants[variant];
    // Disabled state
    var disabledStyles = disabled
        ? {
            opacity: 0.5,
            cursor: "not-allowed",
        }
        : {
            color: colorStyle.color,
        };
    var handleMouseEnter = function (e) {
        if (!disabled) {
            e.currentTarget.style.backgroundColor = colorStyle.hoverBg;
            e.currentTarget.style.color = colorStyle.hoverColor;
        }
    };
    var handleMouseLeave = function (e) {
        if (!disabled) {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.color = colorStyle.color;
        }
    };
    return (React.createElement("button", { onClick: disabled ? undefined : onClick, className: className, style: __assign(__assign(__assign({}, baseStyles), sizeStyles[size]), disabledStyles), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, disabled: disabled, title: title, type: "button" },
        React.createElement(FontAwesomeIcon, { icon: icon })));
};
export default ActionButton;
